import React, { useState, useRef, useEffect } from "react";
import DataTable from "./DataTable";
import "./EditDriver.css";
import useHttp from "../../Hooks/use-http";
import PortalTitle from "../CommonComponent/PortalTitle";
import { Box } from "@mui/material";
import Button from "../CommonComponent/Button";
import { useHistory } from "react-router-dom";

// let corporatesData = [];

Array.prototype.includesWithIndex = function (str) {
  for (let i = 0; i < this.length; i++) {
    if (this[i].toLowerCase().includes(str.toLowerCase())) return i;
  }
};
const EditDriver = () => {
  const [filteredCorporates, setFilteredCorporates] = useState([]);
  const [cpPrivateDriverData, setCpPrivateDriverData] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isApiCall, setIsApiCall] = useState(false);
  const [selectedCp, setSelectedCp] = useState(null);
  const [corporateData, setCorporateData] = useState([]);
  const [driverType, setDriverType] = useState("private");
  const [isAddDriverClicked, setIsAddDriverClicked] = useState(false);
  const history = useHistory();

  const driversData = (data) => {
    // setCpPrivateDriverData(data.Driverlist);
    setCpPrivateDriverData(data.DriverList);

    setIsDataLoading(false);
    setIsApiCall(false);
  };

  const { isLoading, sendRequest } = useHttp();
  const isSuperAdmin = localStorage.getItem("roleId");
  // Trigger API initially on mount
  useEffect(() => {
    setIsApiCall(true); // Set to true on component mount
  }, []);
  useEffect(() => {
    if (isApiCall) {
      sendRequest(
        {
          url: "/corporatedrivers",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),

            data: {
              corporateID: null,
              roleID: localStorage.getItem("roleId"),
            },
          },
        },
        driversData
      );
    }
  }, [sendRequest, isApiCall, isSuperAdmin]);

  return (
    <div className="privateDriver-addEdit">
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <DataTable
          driverType={driverType}
          setDriverType={setDriverType}
          privateDrivers={cpPrivateDriverData ?? []}
          setIsApiCall={setIsApiCall}
          dataLoading={isLoading}
          selectedCorporateDetails={selectedCp}
          setSelectedCorporateDetails={setSelectedCp}
          // corporateNameClickHandler={corporateNameClickHandler}
          filteredCorporates={filteredCorporates}
          setFilteredCorporates={setFilteredCorporates}
          corporateData={corporateData}
          setCorporateData={setCorporateData}
          isApiCall={isApiCall}
          isAddDriverClicked={isAddDriverClicked}
          setIsAddDriverClicked={setIsAddDriverClicked}
        />
      </Box>
    </div>
  );
};

export default EditDriver;
